import React from 'react'
import { Box } from '@mui/material'
import { EmtModal, EmtButton, EmtTypography } from 'emt-components-v2'
import AnimalIncrement from '@/components/PetSitter/AnimalIncrement'

type Props = {
  open: boolean
  onClose: () => void
  animalCounts: {
    dog: number
    cat: number
    nac: number
  }
  onChange: (type: 'dog' | 'cat' | 'nac', delta: number) => void
}

const EditPetsModal: React.FC<Props> = ({ open, onClose, animalCounts, onChange }) => {
  return (
    <EmtModal open={open} onClose={onClose} disableScrollLock>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <EmtTypography variant="h4" fontWeight={800}>
          Modifier les animaux
        </EmtTypography>

        <AnimalIncrement slug="dog" count={animalCounts.dog} onChange={(d) => onChange('dog', d)} />
        <AnimalIncrement slug="cat" count={animalCounts.cat} onChange={(d) => onChange('cat', d)} />
        <AnimalIncrement slug="nac" count={animalCounts.nac} onChange={(d) => onChange('nac', d)} />

        <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
          <EmtButton fullWidth variant="outlined" color="purple" onClick={onClose}>
            Annuler
          </EmtButton>

          <EmtButton fullWidth color="purple" onClick={onClose}>
            Valider
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default EditPetsModal
